// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanelSection from 'viewmodel/AwPanelSectionViewModel';
import AwCommandBar from 'viewmodel/AwCommandBarViewModel';
import AwFlexColumn from 'viewmodel/AwFlexColumnViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwTabSet from 'viewmodel/AwTabSetViewModel';
import AwSidenav from 'viewmodel/AwSidenavViewModel';
import { EnableWhen, VisibleWhen } from 'js/hocCollection';
const AwCommandBarEnableWhen = EnableWhen(AwCommandBar);
const DivVisibleWhen = VisibleWhen('div');
AwCommandBarEnableWhen.displayName = 'AwCommandBarEnableWhen';
DivVisibleWhen.displayName = 'DivVisibleWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/appCtxService', () => import('js/appCtxService'));
registerDynImportEntry('js/rfqHelper', () => import('js/rfqHelper'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "sideNavLeftData": {
      "slide": "PUSH",
      "direction": "LEFT_TO_RIGHT",
      "animation": true,
      "width": "STANDARD",
      "height": "FULL"
    },
    "sideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "buttonCommand": {
      "action": "anAction",
      "iconName": "Add",
      "tooltip": "{{i18n.addSuppliers}}"
    },
    "tabModels": [{
      "name": "Content",
      "tabKey": "contentPage"
    }]
  },
  "actions": {
    "performOnMountBatchAction": {
      "actionType": "batchJob",
      "steps": [{
        "action": "addSessionToCtx"
      }, {
        "action": "addCsIdToCtx"
      }, {
        "action": "addRfqQuoteIdToCtx"
      }, {
        "action": "publishUpdateLabelEvent"
      }]
    },
    "addSessionToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.accsessionid",
        "value": "{{props.accsessionid}}"
      }
    },
    "addCsIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.collaborationspaceid",
        "value": "{{props.collaborationspaceid}}"
      }
    },
    "addRfqQuoteIdToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "rfq.rfqquoteid",
        "value": "{{props.rfqquoteid}}"
      }
    },
    "addQuoteStatusToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "quoteStatus",
        "value": "{{parameters.eventData}}"
      }
    },
    "addContentCountToCtx": {
      "actionType": "JSFunction",
      "method": "updateCtx",
      "deps": "js/appCtxService",
      "inputData": {
        "name": "contentsAdded",
        "value": "{{parameters.eventData}}"
      }
    },
    "openAddContentPopup": {
      "actionType": "Event",
      "method": "Event",
      "inputData": {
        "events": [{
          "name": "awsidenav.openClose",
          "eventData": {
            "id": "sidenavPushRight",
            "includeView": "AddContentsCommandPanel",
            "commandId": "sidenavPushCommandRightAddContents"
          }
        }]
      }
    },
    "publishUpdateLabelEvent": {
      "actionType": "JSFunction",
      "method": "publishEvent",
      "inputData": {
        "eventName": "updateRfqQuoteDetailLabelsConsolidateView"
      },
      "deps": "js/rfqHelper"
    }
  },
  "onEvent": [{
    "eventId": "enableProcessActionButtons",
    "action": "addQuoteStatusToCtx",
    "inputArgs": {
      "eventData": "{{eventData.quoteStatus}}"
    }
  }, {
    "eventId": "enableSubmitActionButtons",
    "action": "addContentCountToCtx",
    "inputArgs": {
      "eventData": "{{eventData.conetentsAdded}}"
    }
  }, {
    "eventId": "add-content-event",
    "action": "openAddContentPopup",
    "cacheEventData": true
  }],
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqquoteid": {
      "type": "string"
    }
  },
  "lifecycleHooks": {
    "onMount": "performOnMountBatchAction"
  },
  "conditions": {
    "showContentPage": {
      "expression": "data.selectedTab.tabKey === 'contentPage'"
    },
    "enableProcessIcons": {
      "expression": "ctx.quoteStatus === 'New request'"
    },
    "enableSubmitIcons": {
      "expression": "ctx.contentsAdded === 'True' && ctx.quoteStatus === 'Acknowledged'"
    }
  },
  "i18n": {
    "addSuppliers": ["RfqMessages"],
    "quoteFiles": ["RfqMessages"],
    "supplierFiles": ["RfqMessages"]
  },
  "_viewModelId": "ViewRfqQuote",
  "_uniqueViewModelId": "ViewRfqQuote",
  "ctx": {
    "quoteStatus": {
      "type": "object"
    },
    "contentsAdded": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table>
        <tr>
            <des-get-rfq-quote-details acc-session-id="{{props.accsessionid}}"
                collaborationspace-id="{{props.collaborationspaceid}}" rfq-quote-id="{{props.rfqquoteid}}">
            </des-get-rfq-quote-details>            
            <aw-panel-section class="aw-layout-full" caption="Quote Files">
                <table>
                    <tr class="rfqViewColumHeight">
                        <td class="rfqquoteViewCommandWidth">
                            <aw-command-bar enable-when="conditions.enableProcessIcons" show-command-labels="true"
                            anchor="viewRfqQuoteCommandAnchor" alignment="HORIZONTAL"></aw-command-bar>
                        </td>
                        <td class="rfqViewCommandWidth">
                            <aw-command-bar enable-when="conditions.enableSubmitIcons" show-command-labels="true"
                            anchor="viewSubmitCommandAnchor" alignment="HORIZONTAL"></aw-command-bar>
                        </td>
                    </tr>
                </table>
                <des-list-rfq-contents acc-session-id="{{props.accsessionid}}"
                    collaborationspace-id="{{props.collaborationspaceid}}" rfq-quote-id="{{props.rfqquoteid}}">
                </des-list-rfq-contents>
            </aw-panel-section>
        </tr>
        <tr>
            <aw-flex-column class="rfqViewColumWidth">                
                <aw-flex-row class="rfqQuoteFlexHeightFill">
                    <aw-flex-column class="rfqQuoteFlexWidthFill">
                        <aw-tab-set tabs="data.tabModels">
                            <div visible-when="conditions.showContentPage">
                                <aw-command-bar show-command-labels="true" anchor="showAddContentsCommandAnchor"
                                    alignment="HORIZONTAL"></aw-command-bar>
                            </div>
                            <div visible-when="conditions.showContentPage">
                                <des-list-rfq-quote-contents acc-session-id="{{props.accsessionid}}"
                                    collaborationspace-id="{{props.collaborationspaceid}}"
                                    rfq-quote-id="{{props.rfqquoteid}}">
                                </des-list-rfq-quote-contents>
                            </div>
                        </aw-tab-set>
                    </aw-flex-column>
                    <aw-sidenav id="sidenavPushRight" config="data.sideNavRightData"></aw-sidenav>
                </aw-flex-row>
            </aw-flex-column>
        </tr>
    </table>
</div>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("des-get-rfq-quote-details", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-quote-id": AwParseService.instance("props.rfqquoteid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(AwPanelSection, {
    className: "aw-layout-full",
    caption: "Quote Files"
  }), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null))), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "rfqViewColumHeight"
  }, /*#__PURE__*/React.createElement("td", {
    className: "rfqquoteViewCommandWidth"
  }, /*#__PURE__*/React.createElement(AwCommandBarEnableWhen, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "viewRfqQuoteCommandAnchor",
    alignment: "HORIZONTAL",
    enableWhen: AwParseService.instance("conditions.enableProcessIcons")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })), /*#__PURE__*/React.createElement("td", {
    className: "rfqViewCommandWidth"
  }, /*#__PURE__*/React.createElement(AwCommandBarEnableWhen, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "viewSubmitCommandAnchor",
    alignment: "HORIZONTAL",
    enableWhen: AwParseService.instance("conditions.enableSubmitIcons")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))))), /*#__PURE__*/React.createElement("des-list-rfq-contents", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-quote-id": AwParseService.instance("props.rfqquoteid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqViewColumWidth"
  }, /*#__PURE__*/React.createElement(AwFlexRow, {
    className: "rfqQuoteFlexHeightFill"
  }, /*#__PURE__*/React.createElement(AwFlexColumn, {
    className: "rfqQuoteFlexWidthFill"
  }, /*#__PURE__*/React.createElement(AwTabSet, {
    updateHook: AwParseService.instance("{data, conditions,dispatch }")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    tabs: AwParseService.instance("data.tabModels")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showContentPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwCommandBar, {
    showCommandLabels: AwParseService.instance("true")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    anchor: "showAddContentsCommandAnchor",
    alignment: "HORIZONTAL"
  })), /*#__PURE__*/React.createElement(DivVisibleWhen, {
    visibleWhen: AwParseService.instance("conditions.showContentPage")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement("des-list-rfq-quote-contents", {
    "acc-session-id": AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "collaborationspace-id": AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    "rfq-quote-id": AwParseService.instance("props.rfqquoteid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  })))), /*#__PURE__*/React.createElement(AwSidenav, {
    id: "sidenavPushRight",
    config: AwParseService.instance("data.sideNavRightData")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;